import React, { useState } from 'react';
import { Typography, Box } from '@mui/material';
import ActivityLayout from '../ActivityLayout';
import { useGameUtils } from '../../hooks/useGameUtils';

function SortDominos({ onBack, onCorrect, initialTimer = null, globalTimer = null, onGlobalTimeUp, score }) {
  const { dominoUnicode } = useGameUtils();
  const [numbers, setNumbers] = useState(() => generateNumbers());
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [emoji, setEmoji] = useState(null);
  const [showNext, setShowNext] = useState(false);

  function generateNumbers() {
    const count = 5;
    const nums = Array.from({ length: count }, (_, i) => i);
    return nums.sort(() => Math.random() - 0.5);
  }

  const handleDominoClick = (index) => {
    if (showNext) return;

    if (selectedIndex === null) {
      setSelectedIndex(index);
    } else {
      // Swap numbers
      const newNumbers = [...numbers];
      const temp = newNumbers[selectedIndex];
      newNumbers[selectedIndex] = newNumbers[index];
      newNumbers[index] = temp;
      setNumbers(newNumbers);
      setSelectedIndex(null);

      // Check if numbers are in order
      const isOrdered = newNumbers.every((num, i) => i === 0 || num > newNumbers[i - 1]);
      if (isOrdered) {
        setEmoji('🎉');
        setShowNext(true);
        onCorrect();
      }
    }
  };

  const handleNext = () => {
    setNumbers(generateNumbers());
    setSelectedIndex(null);
    setEmoji(null);
    setShowNext(false);
  };

  return (
    <ActivityLayout 
      onBack={onBack}
      timeLimit={initialTimer}
      globalTimeLimit={globalTimer}
      onTimeUp={() => {
        setEmoji('⏰');
        setShowNext(true);
      }}
      onGlobalTimeUp={onGlobalTimeUp}
      isPaused={showNext}
      score={score}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
          mt: 4,
        }}
      >
        <Typography variant="h6">
          Mettez les dominos dans l'ordre croissant
        </Typography>

        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 2,
            justifyContent: 'center',
            mt: 2,
          }}
        >
          {numbers.map((number, index) => (
            <Box
              key={index}
              onClick={() => handleDominoClick(index)}
              sx={{
                cursor: showNext ? 'default' : 'pointer',
                border: selectedIndex === index ? '3px solid blue' : '1px solid black',
                borderRadius: '8px',
                padding: '10px',
                backgroundColor: 'white',
                '&:hover': {
                  backgroundColor: showNext ? 'white' : '#f0f0f0',
                },
              }}
            >
              <Typography variant="h2">{dominoUnicode[number]}</Typography>
            </Box>
          ))}
        </Box>

        {emoji && (
          <Typography variant="h1">{emoji}</Typography>
        )}

        {showNext && (
          <Box
            onClick={handleNext}
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(255, 255, 255, 0.8)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              fontSize: '2rem',
            }}
          >
            {emoji} {emoji === '⏰' ? 'Time\'s up!' : 'Click to continue'}
          </Box>
        )}
      </Box>
    </ActivityLayout>
  );
}

export default SortDominos;
